import { render, staticRenderFns } from "./playersADT.vue?vue&type=template&id=381a00da&scoped=true"
import script from "./playersADT.vue?vue&type=script&lang=js"
export * from "./playersADT.vue?vue&type=script&lang=js"
import style0 from "./playersADT.vue?vue&type=style&index=0&id=381a00da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a00da",
  null
  
)

export default component.exports